module.exports = __webpack_public_path__ + "img/round3-iteration2-1.e99b743d.png";